import React, { createContext, useContext, useState, useCallback } from 'react';
import { fetchSubscriptionStatus } from '../bridge';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [userEmail, setUserEmail] = useState(() => sessionStorage.getItem('userEmail') || null);
  const [isLoggedIn, setIsLoggedIn] = useState(() => !!sessionStorage.getItem('userEmail'));
  const [isSubscribed, setIsSubscribed] = useState(() => sessionStorage.getItem('isSubscribed') === 'true');

  const login = (email) => {
    sessionStorage.setItem('userEmail', email);
    setUserEmail(email);
    setIsLoggedIn(true);
  };

  const logout = () => {
    sessionStorage.removeItem('userEmail');
    sessionStorage.removeItem('isSubscribed');
    setUserEmail(null);
    setIsLoggedIn(false);
    setIsSubscribed(false);
  };

  // Fetch subscription status from DB and sync to state + localStorage.
  // Call this on Manage page mount and after returning from Stripe.
  const refreshSubscription = useCallback(async (email) => {
    const target = email || userEmail;
    if (!target) return false;
    const subscribed = await fetchSubscriptionStatus(target);
    sessionStorage.setItem('isSubscribed', String(subscribed));
    setIsSubscribed(subscribed);
    return subscribed;
  }, [userEmail]);

  return (
    <AuthContext.Provider value={{ userEmail, isLoggedIn, isSubscribed, login, logout, refreshSubscription }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
